import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductDiscounts', request)
}

async function put(request) {
    return await putMethod('/api/ownProductDiscounts', request)
}

async function post(body) {
    return await postMethod('/api/ownProductDiscounts', body)
}

export {get, put, post}
